import { render, staticRenderFns } from "./HomeCouncil.vue?vue&type=template&id=f1ddb586&scoped=true&"
import script from "./HomeCouncil.vue?vue&type=script&lang=js&"
export * from "./HomeCouncil.vue?vue&type=script&lang=js&"
import style0 from "./HomeCouncil.vue?vue&type=style&index=0&id=f1ddb586&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1ddb586",
  null
  
)

export default component.exports